
import { Helmet } from 'react-helmet-async';

interface StructuredDataProps {
  type: 'Organization' | 'LocalBusiness' | 'WebPage' | 'BreadcrumbList' | 'FAQ';
  data: any;
}

export const StructuredData = ({ type, data }: StructuredDataProps) => {
  let schema = {};

  switch (type) {
    case 'Organization':
      schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "The PEO App",
        "url": "https://thepeoapp.com",
        "logo": "https://thepeoapp.com/logo.jpg",
        "description": "Professional Employer Organization (PEO) matching service connecting businesses with vetted PEO providers",
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "Customer Service",
          "url": "https://thepeoapp.com/application"
        },
        "sameAs": [
          "https://www.linkedin.com/company/the-peo-app"
        ],
        ...data
      };
      break;

    case 'LocalBusiness':
      schema = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "The PEO App",
        "image": "https://thepeoapp.com/logo.jpg",
        "url": "https://thepeoapp.com",
        "telephone": "+1-555-PEO-HELP",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "39.8283",
          "longitude": "-98.5795"
        },
        "openingHours": "Mo-Fr 09:00-17:00",
        "priceRange": "$$",
        ...data
      };
      break;

    case 'WebPage':
      schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": data.name,
        "description": data.description,
        "url": data.url,
        "mainEntity": {
          "@type": "Organization",
          "name": "The PEO App"
        },
        ...data
      };
      break;

    case 'BreadcrumbList':
      schema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": data.items.map((item: any, index: number) => ({
          "@type": "ListItem",
          "position": index + 1,
          "name": item.name,
          "item": item.url
        }))
      };
      break;

    case 'FAQ':
      schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": data.questions.map((q: any) => ({
          "@type": "Question",
          "name": q.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": q.answer
          }
        }))
      };
      break;

    default:
      schema = data;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
